export default __webpack_public_path__ + "static/media/output-tab.015cc02f.jpg";